export const defaultCommonSearchModel = {
  collectionSeason: new Date().getFullYear().toString(),
  tenderNo: "",
  companyName: "",
  emailAddress: "",
  lotNo: "",
};
